// storing the ids so we can clear them on logout
let autoLogoutTimerId = null; // stores the id for setTimeout which triggers signOut on session expiration.
let checkInactivityTimerId = null; // stores the id for setTimeout func which is triggered when the session is about to expire.

export const setCheckInactivityTimer = (callbackFunc, timeout) => {
    // a timeout for 23 hours and 30 minutes to check if user is active 30 mins before the session expires.
    checkInactivityTimerId = setTimeout(() => callbackFunc(), timeout);
};

export const setAutoLogoutTimer = (callbackFunc, timeout) => {
    // auto logout in 30 minutes if no response from user
    autoLogoutTimerId = setTimeout(() => callbackFunc(), timeout);
};

export const clearCheckInactivityTimer = () => {
    clearTimeout(checkInactivityTimerId);
};

export const clearAutoLogoutTimer = () => {
    clearTimeout(autoLogoutTimerId);
};